module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-box"
  }, [_c('el-button', {
    directives: [{
      name: "edit",
      rawName: "v-edit:customer",
      value: (_vm.customer),
      expression: "customer",
      arg: "customer"
    }],
    staticClass: "pull-right",
    attrs: {
      "type": "warning",
      "size": "mini",
      "icon": "el-icon-edit",
      "circle": ""
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "header-title m-t-0 m-b-20"
  }, [_vm._v("Informations")]), _vm._v(" "), _c('ul', {
    staticClass: "ul-fa"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-id-card"
  }), _vm._v(" "), _c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "name"
    }
  })], 1), _vm._v(" "), (_vm.customer.job_type) ? _c('li', [_c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "job"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "city"
    }
  })], 1), _vm._v(" "), (_vm.customer.contact_details.first_phone) ? _c('li', [_c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "first_phone"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.customer.contact_details.second_phone) ? _c('li', [_c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "second_phone"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.customer.contact_details.email) ? _c('li', [_c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "email"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.customer.contact_details.website) ? _c('li', [_c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "website"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "remarks"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ff75128"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Widgets/Customers/Summary/CustomerInformationsSummaryWidget.vue
// module id = 690
// module chunks = 1